import React from 'react';

function FeedbackClockIcon() {
  return (
    <svg width={24} height={24} fill="none">
      <title>Ilustração de relógio</title>
      <path d="M11.62 12.3a1.44 1.44 0 11-1.1-2.658V4.76h.96v4.882a1.44 1.44 0 01.82 1.979l4.412 4.412-.68.679-4.411-4.412zM3.32.92h15.36c1.68 0 2.4.72 2.4 2.4v15.36c0 1.68-.72 2.4-2.4 2.4H3.32c-1.68 0-2.4-.72-2.4-2.4V3.32c0-1.68.72-2.4 2.4-2.4zm16.8 17.76V3.32c0-1.15-.29-1.44-1.44-1.44H3.32c-1.15 0-1.44.29-1.44 1.44v15.36c0 1.15.29 1.44 1.44 1.44h15.36c1.15 0 1.44-.29 1.44-1.44zM11 11.48a.48.48 0 100-.96.48.48 0 000 .96z" fill="#111" />
    </svg>
  );
}

export default FeedbackClockIcon;
